import BasicTableContainer from "../../../../components/formsAndTable/tables/reactstrapTables/basicTables";

const BasicTables = () => {
  return <BasicTableContainer />;
};

export default BasicTables;
